import React from "react";
import { CalendarCheck, FileText } from "lucide-react";
import { useBooking } from "@/context/BookingContext";
import { useLead } from "@/context/LeadContext";

export const MobileStickyCTA = () => {
  const { openBooking } = useBooking();
  const { openForm } = useLead();
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex gap-2 p-3 bg-white/95 backdrop-blur border-t border-border"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.75rem)" }}
    >
      <button
        data-testid="sticky-book-btn"
        onClick={openBooking}
        className="cta flex-1 inline-flex items-center justify-center gap-2 bg-royal text-white font-extrabold text-base px-4 py-3.5 rounded-sm hover:bg-royal-hover shadow-lg shadow-royal/30"
      >
        <CalendarCheck className="w-5 h-5" /> Réserver mon créneau
      </button>
      <button
        data-testid="sticky-quote-btn"
        onClick={() => openForm("auto")}
        aria-label="Obtenir mon devis"
        className="cta inline-flex items-center justify-center bg-ink text-white px-4 py-3.5 rounded-sm hover:bg-ink-light"
      >
        <FileText className="w-5 h-5" />
      </button>
    </div>
  );
};
